import { createReducer, on } from '@ngrx/store';
import * as DocumentDetailsActions from './document-details.actions';
import { DocumentDetailsEntity } from './document-details.models';

export const DOCUMENT_DETAILS_FEATURE_KEY = 'documentDetails';

export interface DocumentDetailsState {
  documentDetails: DocumentDetailsEntity | null;
  loaded: boolean;
  error?: string | null;
}

export const initialDocumentDetailsState: DocumentDetailsState = {
  documentDetails: null,
  loaded: false,
  error: null,
};

const reducer = createReducer(
  initialDocumentDetailsState,
  on(DocumentDetailsActions.initDocumentDetails, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(DocumentDetailsActions.clearDocumentDetails, () => initialDocumentDetailsState),
  on(DocumentDetailsActions.loadDocumentDetailsSuccess, (state, { documentDetails }) => ({
    ...state,
    documentDetails,
    loaded: true,
    error: null,
  })),
  on(DocumentDetailsActions.loadDocumentDetailsFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  }))
);

export function documentDetailsReducer(state: DocumentDetailsState | undefined, action: any) {
  return reducer(state, action);
}
